import { PostTypes } from 'model';
import { IconCalendar, IconQuestion, IconPoll, IconLocation, IconBusiness, IconCurrency } from './QuirkIcons';
import { IconSize } from './QuirkIcons/QuirkIcon';

export interface PostTypeIconProps {
	postType: PostTypes;
	size?: IconSize;
}

export function PostTypeIcon({ postType, size = 'small' }: PostTypeIconProps) {
	switch (postType) {
		case 'event':
			return <IconCalendar size={size} />;
		case 'communityQuestion':
			return <IconQuestion size={size} />;
		case 'basic':
			return null;
		case 'poll':
			return <IconPoll size={size} />;
		case 'businessCheckIn':
			return <IconLocation size={size} />;
		case 'businessPost':
			return <IconBusiness size={size} />;
		case 'marketplaceItem':
			return <IconCurrency size={size} />;
		default:
			return null;
	}
}
